import highlights from '@/mixins/search/highlights'

export default {
  mixins: [highlights],
  props: {
    highlights: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    highlightsLoading: {
      type: Boolean,
      required: true
    },
    link: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      abstractPrefix: '<span class="t-500">Abstract: </span>'
    }
  },
  computed: {
    title () {
      return this.highlights && this.highlights.title ? this.highlights.title[0] : this.data.title
    },
    abstract () {
      return this.highlights && this.highlights.abstract
        ? `${this.abstractPrefix} ${this.stripTagsNoMark(this.highlights.abstract)}`
        : (!this.isEmpty(this.data.abstract)) ? `${this.abstractPrefix} ${this.stripTagsNoMark(this.data.abstract)}` : ''
    },
    journal () {
      if (!this.isEmpty(this.data.locations)) {
        const journal = this.data.locations.find(l => l.category === 'journal')
        return journal
      }
      return ''
    },
    researchGroups () {
      return this.data.research_groups
    },
    authors () {
      return this.getFirstXElAndLastFromArr(this.data.top_authors, this.maxAuthors)
    }
  }
}
